import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseURL = '/PaymentsAndDeductions';

export interface IPaymentsAndDeductions {
  part: string;
  requestNumber: number | string;
  appMaanakSum: number | null;
  statusDate: Date;
  statusCode: number;
  benefitGroupCode: number;
  linkedApplyNumbers: string[];
  payStartDate?: Date;
  payEndDate?: Date;
  payFromDate?: Date;
  payUntilDate?: Date;
  paymentDurationInMonths?: number;
}

export const getPaymentAndDeductions = async () => {
  const paymentAndDeductions = await api.get<IPaymentsAndDeductions[]>(
    addImposterToUrl(`${baseURL}`, true)
  );
  if (paymentAndDeductions.data) return paymentAndDeductions.data;
};
